// Components & Data Imports
import Footer from '../layout/Footer'
import R2016 from '../resources/imgs/R2016.webp'
import R2017 from '../resources/imgs/R2017.webp'
import R2018 from '../resources/imgs/R2018.webp'
import R2019 from '../resources/imgs/R2019.webp'
import R2020 from '../resources/imgs/R2020.webp'
import R2021 from '../resources/imgs/R2021.webp'
import R2022 from '../resources/imgs/R2022.webp'
import R2023 from '../resources/imgs/R2023.webp'
import R2024 from '../resources/imgs/R2024.webp'
import R2025 from '../resources/imgs/R2025.webp'

// Icons
import { RiGalleryFill } from 'react-icons/ri'

const Gallery = () => {
  return (
    <>
      <div className='gallery'>
        <div className='news-bg'></div>
        <div className='news-heading'>
          <RiGalleryFill className='news-heading-icon' />
          <div className='news-heading-title'>Galerie</div>
          <div className='news-heading-subtitle'>Vzpomínky v obrazech</div>
        </div>
        <div className='gallery-container'>
          <a href='https://photos.app.goo.gl/6fF3fUrnEFh3Fghf8' target='blank'>
            <img
              src={R2025}
              alt='Český Šternberk 2025'
              className='gallery-container-item gallery-container-item-1'
            />
          </a>
          <a href='https://photos.app.goo.gl/ws95ezYPnCdjjgPT9' target='blank'>
            <img
              src={R2024}
              alt='Tomášov 2024'
              className='gallery-container-item gallery-container-item-2'
            />
          </a>
          <a href='https://photos.app.goo.gl/99TSw1kGsmqnuhYC9' target='blank'>
            <img
              src={R2023}
              alt='Tomášov 2023'
              className='gallery-container-item gallery-container-item-1'
            />
          </a>
          <a href='https://photos.app.goo.gl/8meVzuvRCvsRnLgT6' target='blank'>
            <img
              src={R2022}
              alt='Stvolínky 2022'
              className='gallery-container-item gallery-container-item-2'
            />
          </a>
          <a href='https://photos.app.goo.gl/5rJMfNZHfc2uy39R7' target='blank'>
            <img
              src={R2021}
              alt='Božanov 2021'
              className='gallery-container-item gallery-container-item-1'
            />
          </a>
          <a href='https://photos.app.goo.gl/MA9WB47smDXv7nZ78' target='blank'>
            <img
              src={R2020}
              alt='Božanov 2020'
              className='gallery-container-item gallery-container-item-2'
            />
          </a>
          <a href='https://photos.app.goo.gl/pPUzQt8ZC5urJd4V8' target='blank'>
            <img
              src={R2019}
              alt='Božanov 2019'
              className='gallery-container-item gallery-container-item-1'
            />
          </a>
          <a href='https://photos.app.goo.gl/WcmutuDGyR9GPvnRA' target='blank'>
            <img
              src={R2018}
              alt='Božanov 2018'
              className='gallery-container-item gallery-container-item-2'
            />
          </a>
          <a href='https://photos.app.goo.gl/4G2gD3GvmwrAMkTWA' target='blank'>
            <img
              src={R2017}
              alt='Božanov 2017'
              className='gallery-container-item gallery-container-item-1'
            />
          </a>
          <a href='https://photos.app.goo.gl/WbpxhqJbG47VtDLG6' target='blank'>
            <img
              src={R2016}
              alt='Čmelák 2016'
              className='gallery-container-item gallery-container-item-2'
            />
          </a>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Gallery
